export default __webpack_public_path__ + "static/Денежный поток 1-91f51755a9b5581f1fc7a84c6edd2156.jpg";